__turbopack_context__.v({
  "isProduct": "ProductServices_List-module-scss-module__zT13bG__isProduct",
  "root": "ProductServices_List-module-scss-module__zT13bG__root",
  "row": "ProductServices_List-module-scss-module__zT13bG__row",
  "title": "ProductServices_List-module-scss-module__zT13bG__title",
  "titleTop": "ProductServices_List-module-scss-module__zT13bG__titleTop",
  "wrap": "ProductServices_List-module-scss-module__zT13bG__wrap",
});
